import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

type Theme = 'light' | 'dark'

interface ThemeState {
  theme: Theme
  toggleTheme: () => void
  setTheme: (theme: Theme) => void
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      theme: 'dark', // Padrão Nebula OS v4.0 é Dark
      toggleTheme: () => set((state) => {
        const nextTheme = state.theme === 'dark' ? 'light' : 'dark'
        // Atualiza a classe/atributo no document element para fins de estilo CSS global
        if (typeof document !== 'undefined') {
          document.documentElement.setAttribute('data-theme', nextTheme)
        }
        return { theme: nextTheme }
      }),
      setTheme: (theme) => set(() => {
        if (typeof document !== 'undefined') {
          document.documentElement.setAttribute('data-theme', theme)
        }
        return { theme }
      }),
    }),
    {
      name: 'gsp-theme',
      storage: createJSONStorage(() => localStorage),
    }
  )
)
